import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TooltipPopperMixin } from '../../mixins/components/TooltipPopperMixin';
import { Popper } from '../Popper/Popper';

/**
 * A `Popper` configured specifically for tooltips. Ensures that tooltips are visible on focus or
 * hover by default.
 *
 * @extends Popper
 * @related ['Tooltip', 'Trigger']
 * @since 7.0.0
 */
var TooltipPopper = /*#__PURE__*/styled(Popper).withConfig({
  displayName: "TooltipPopper",
  componentId: "c11n-8-111-1__sc-1v2hxhd-0"
})(["", ""], TooltipPopperMixin);
TooltipPopper.displayName = 'TooltipPopper';
TooltipPopper.propTypes = {
  /**
   * Trigger has aria-haspopup defined by default, however aria does not consider a tooltip to be
   * a popup in this case. Need to set this to false.
   *
   * @ignore
   */
  'aria-haspopup': PropTypes.string,
  /**
   * The `Trigger` `mouseEnterDelay` prop.
   */
  'mouseEnterDelay': PropTypes.number,
  /**
   * The `Trigger` `mouseLeaveDelay` prop.
   */
  'mouseLeaveDelay': PropTypes.number,
  /**
   * The `Trigger` `openWith` prop.
   */
  'openWith': PropTypes.arrayOf(PropTypes.string),
  /**
   * The `Trigger` `closeWith` prop.
   */
  'closeWith': PropTypes.arrayOf(PropTypes.string),
  /**
   * The `Trigger` `generateDescribedBy` prop.
   */
  'generateDescribedBy': PropTypes.bool
};
TooltipPopper.defaultProps = {
  'aria-haspopup': 'false',
  'mouseEnterDelay': 500,
  'mouseLeaveDelay': 500,
  'openWith': ['click', 'focus', 'mouseEnter'],
  'closeWith': ['click', 'blur', 'mouseLeave'],
  'generateDescribedBy': true,
  'shouldFocusTriggered': false,
  'shouldCloseOnViewportLeave': true
};

/** @component */
export { TooltipPopper };